<template>
  <div>
    <v-dialog v-model="isShowDescription" persistent :max-width="isDuoMeter ? 720 : 960">
      <v-card class="mx-auto" :loading="querying">
        <template slot="progress">
          <v-progress-linear
            color="green darken-3"
            height="8"
            indeterminate
          ></v-progress-linear>
        </template>

        <div class="pa-6">
          <div style="position: absolute; top: 3%; right: 3%;">
            <v-row justify="end">
              <v-icon
                large
                color="red darken-1"
                @click.prevent="isCloseDescription()"
                style="margin-right: 12px"
              >
                mdi-close
              </v-icon>
            </v-row>
          </div>

          <!-- TITLE -->
          <v-row align="center" class="mb-4">
            <v-col cols="12" md="2" align="center">
              <v-avatar color="grey darken-3" size="96" class="mr-4">
                <v-icon dark size="72">mdi-tower-fire</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" md="10" class="px-6">
              <v-row>
                <h2>{{ title }}</h2>
              </v-row>
              <v-row>
                <h5 class="text--card-subtitle">{{ siteTitle.title }} &nbsp;</h5>
                <h5 class="text--card-subtitle">{{ siteTitle.subTitle }}</h5>
              </v-row>
            </v-col>
          </v-row>

          <!-- Description Chart -->
          <v-row>
            <!-- Box Value -->
            <v-col cols="12" :md="isDuoMeter ? 6 : 4">
              <BoxCard
                :value="sensor1Value"
                :sensorType="sensorType1BoxCard"
              ></BoxCard>
            </v-col>
            <!-- Box Value -->
            <v-col cols="12" :md="isDuoMeter ? 6 : 4">
              <BoxCard
                :value="sensor2Value"
                :sensorType="sensorType2BoxCard"
              ></BoxCard>
            </v-col>
            <!-- Box Value -->
            <v-col cols="12" md="4" v-if="!isDuoMeter">
              <BoxCard
                :value="sensor3Value"
                :sensorType="sensorType3BoxCard"
              ></BoxCard>
            </v-col>
            <!-- Time filter function -->
            <template v-if="!isDuoMeter">
              <v-col cols="12">
                <h5>
                  กราฟเส้นแสดงค่า {{ sensorName1BoxCard }} (Y1) ใน 
                  1 {{ btnList_datetime[btnSelected_datetime]["titleTh"] }}ที่ผ่านมา
                </h5>
                <v-row class="mx-0 mt-2">
                  <v-btn
                    class="button-datetime-filter mr-2"
                    v-for="item in btnList_datetime"
                    :key="item.id"
                    :color="
                      btnSelected_datetime == item.id ? 'grey lighten-1' : undefined
                    "
                    @click="clickFilter_datetime(item.id)"
                    depressed
                    small
                  >
                    {{ item.name }}
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-0">
                <AreaChart
                  :yData="sensor1Serie"
                  :yLabel="'Pressure'"
                ></AreaChart>
              </v-col>
            </template>
            <v-col cols="12" class="pb-0">
              <h5>
                กราฟเส้นแสดงค่า {{ isDuoMeter ? sensorName1BoxCard : sensorName2BoxCard }} (Y1) และ 
                {{ isDuoMeter ? sensorName2BoxCard : sensorName3BoxCard }} (Y2) ใน 
                1 {{ btnList_datetime[btnSelected_datetime]["titleTh"] }}ที่ผ่านมา
              </h5>
              <v-row class="mx-0 mt-2" v-if="isDuoMeter">
                <v-btn
                  class="button-datetime-filter mr-2"
                  v-for="item in btnList_datetime"
                  :key="item.id"
                  :color="
                    btnSelected_datetime == item.id ? 'grey lighten-1' : undefined
                  "
                  @click="clickFilter_datetime(item.id)"
                  depressed
                  small
                >
                  {{ item.name }}
                </v-btn>
              </v-row>
            </v-col>
            <!-- Chart -->
            <v-col cols="12" class="py-0">
              <MultipleLineChart
                :y1SensorType="isDuoMeter ? sensorType1BoxCard : sensorType2BoxCard"
                :y2SensorType="isDuoMeter ? sensorType2BoxCard : sensorType3BoxCard"
                :y1Data="isDuoMeter ? sensor1Serie : sensor2Serie"
                :y2Data="isDuoMeter ? sensor2Serie : sensor3Serie"
              ></MultipleLineChart>
            </v-col>
          </v-row>

          <!-- Last Update -->
          <v-row>
            <v-col cols="12" class="pt-0">
              <h5>
                อัปเดตล่าสุด : {{displayDate(lastUpdateDate)}} {{ dataslot_BasedOnFilter == '60' || dataslot_BasedOnFilter == '1' ? `เวลา ${lastUpdateTime}` : '' }}
              </h5>
            </v-col>
          </v-row>

          <!-- PDF Export filter by Date -->
          <v-row>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <!-- HEADER -->
                  <v-expansion-panel-header style="padding: 0px 10px">
                    <v-col cols="2" align="center">
                      <v-avatar color="grey darken-3" size="48" class="">
                        <v-icon dark size="36">mdi-download</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="10">
                      <h3>ดาวน์โหลดข้อมูล</h3>
                    </v-col>
                  </v-expansion-panel-header>
                  <!-- CONTENT -->
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="postData.startDate"
                              label="เริ่มวันที่"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="postData.startDate"
                            @input="menu = false"
                            :max="currentDate"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="postData.endDate"
                              label="สิ้นสุดวันที่"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="postData.endDate"
                            :min="postData.startDate"
                            :max="currentDate"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <!-- PREVIEW BUTTON -->
                    <v-row class="pb-4" align="center" justify="center">
                      <v-btn @click="setPostData()" color="success" large dark>
                        <p class="mb-0">แสดงตัวอย่างเพื่อดาวน์โหลด</p>
                      </v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import services from "@/services/services";
import BoxCard from "@/components/visuals/BoxCard";
import MultipleLineChart from "@/components/visuals/MultipleLineChart";
import AreaChart from "@/components/visuals/AreaChart";

export default {
  name: "PipeMeterModal",

  components: {
    BoxCard,
    MultipleLineChart,
    AreaChart
  },

  props: {
    isShowDescription: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: "",
    },
    monitorType: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    deviceId: {
      type: String,
      default: ""
    },
    siteTitle: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
        }
      }
    },
  },

  data() {
    return {
      querying: false,

      // CURRENT_VALUE
      sensor1Value: 0,
      sensor2Value: 0,
      sensor3Value: 0,

      // LAST UPDATE (DATE/TIME)
      lastUpdateDate: '',
      lastUpdateTime: '',

      // SERIES_VALUE
      sensor1Serie: [
        {
          x: 'HelloWorld_DGR',
          y: 2020
        }
      ],
      sensor2Serie: [
        {
          x: 'HelloWorld_DGR',
          y: 2020
        }
      ],
      sensor3Serie: [
        {
          x: 'HelloWorld_DGR',
          y: 2020
        }
      ],

      // PERIOD_TYPE_FILTER
      btnList_datetime: [
        { id: 0, name: "Hour", titleTh: "ชั่วโมง" },
        { id: 1, name: "Day", titleTh: "วัน" },
        { id: 2, name: "Week", titleTh: "สัปดาห์" },
        { id: 3, name: "Month", titleTh: "เดือน" },
        { id: 4, name: "Year", titleTh: "ปี" },
      ],
      dataslot_BasedOnFilter: 60,
      btnSelected_datetime: 0,

      // PDF DOWNLOAD
      currentDate: moment().format("YYYY-MM-DD"),
      menu: false,
      menu2: false,
      postData: {
        deviceId: "",
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },

      // UnMOUNTED
      polling: null,
    };
  },

  computed: {
    sensorName1BoxCard() {
      switch (this.groupId) {
        case "waterIn": case "mainTankLeft": case "mainTankRightIn":
          return "Flow Rate";
        case "hole":
          return "Level";
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "Pressure";
        default:
          return "Unknown";
      }
    },
    sensorName2BoxCard() {
      switch (this.groupId) {
        case "waterIn": case "mainTankLeft": case "mainTankRightIn":
          return "Total";
        case "hole":
          return "TDS";
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "Flow Rate";
        default:
          return "Unknown";
      }
    },
    sensorName3BoxCard() {
      switch (this.groupId) {
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "Total";
        default:
          return "Unknown";
      }
    },
    sensorType1BoxCard() {
      switch (this.groupId) {
        case "waterIn": case "mainTankLeft": case "mainTankRightIn":
          return "FLOW";
        case "hole":
          return "LEVEL";
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "PRS";
        case "mainTank":
            return "TDS";
        default:
          return "Unknown";
      }
    },
    sensorType2BoxCard() {
      switch (this.groupId) {
        case "waterIn": case "mainTankLeft": case "mainTankRightIn":
          return "TOT";
        case "hole":
          return "TDS";
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "FLOW";
        case "mainTank":
            return "EC";
        default:
          return "Unknown";
      }
    },
    sensorType3BoxCard() {
      switch (this.groupId) {
        case "waterOutLeft": case "waterOutRight": case "mainTankRightOut":
          return "TOT";
        default:
          return "Unknown";
      }
    },
    isDuoMeter() {
      if (this.monitorType === "duoMeter") return true;
      else return false;
    }
  },

  watch: {
    dataslot_BasedOnFilter: function() {
      this.queryDataByPeriod();
    }
  },

  methods: {
    isCloseDescription() {
      this.$emit("onCloseModal", true);
    },
    clickFilter_datetime(id) {
      // console.log('ID: ', id);
      this.btnSelected_datetime = id;
      switch (id) {
        // Hours
        case 0:
          this.dataslot_BasedOnFilter = 60;
          break;
        // Days
        case 1:
          this.dataslot_BasedOnFilter = 1;
          break;
        // Weeks
        case 2:
          this.dataslot_BasedOnFilter = 7;
          break;
        // Months
        case 3:
          this.dataslot_BasedOnFilter = 30;
          break;
        // Years
        case 4:
          this.dataslot_BasedOnFilter = 365;
          break;

        default:
          this.dataslot_BasedOnFilter = 60;
          break;
      }
    },
    displayDate(date) {
      return moment(date, "YYYY-MM-DD").format("วันddddที่ Do MMMM YYYY");
    },
    setPostData() {
      // console.log("deviceId", this.deviceId);
      let routeData = this.$router.resolve({ 
        path: '/export', 
        query: { 
          deviceId: this.deviceId, 
          startDate: this.postData.startDate, 
          endDate: this.postData.endDate 
        }
      })
      window.open(routeData.href, "_blank")
    },
    async queryDataByPeriod() {
      this.querying = true;
      let postData = { 'limit': this.dataslot_BasedOnFilter };
      let res = await services.getMeterDataByPeriod(postData);
      // console.log('desc.Modal - RES: ', res['data']);
      const apiData = res['data'];

      // Check SiteId and Key Data
      // console.log('GROUP.ID: ', this.groupId, '| DEVICE.ID: ', this.deviceId);
      // console.log('1.SENSOR-TYPE: ', this.sensorType1BoxCard, '| 2.SENSOR-TYPE: ', this.sensorType2BoxCard);
      let iotSiteName = null;
      let iotSiteName2 = null;

      // Assign Data
      if (apiData) {
        try {
          this.setLastUpdateDateTime(apiData[0]);
          if (this.deviceId === "4015080300601" || this.deviceId === "4015080301001") {
            this.setMeterValueCurrent(apiData[0]);
            this.setMeterValueSeries(apiData);
          }
        } catch (error) {
          console.error("[SYSTEM] Set value from api failed.", error, this.sensor1Serie)
        }
      }
      this.querying = false;
    },
    setLastUpdateDateTime(data) {
      this.lastUpdateDate = data['date'];
      this.lastUpdateTime = data['time'];
    },
    setMeterValueCurrent(data, data2=[]) {
      var sensor1Id = this.deviceId + this.sensorType1BoxCard;
      var sensor2Id = this.deviceId + this.sensorType2BoxCard;
      this.sensor1Value = Number.parseFloat(data[sensor1Id] !== null ? Math.abs(data[sensor1Id].toFixed(2)) : 'ERR');
      this.sensor2Value = Number.parseFloat(data[sensor2Id] !== null ? Math.abs(data[sensor2Id].toFixed(2)) : 'ERR');
      if (!this.isDuoMeter) {
        var sensor3Id = this.deviceId + this.sensorType3BoxCard;
        this.sensor3Value = Number.parseFloat(data[sensor3Id] !== null ? Math.abs(data[sensor3Id].toFixed(2)) : 'ERR');
      }
    },
    setMeterValueSeries(data, data2=[]) {
      var sensor1Id = this.deviceId + this.sensorType1BoxCard;
      var sensor2Id = this.deviceId + this.sensorType2BoxCard;
      this.sensor1Serie = this.calMeterValueByColumn(data, sensor1Id);
      this.sensor2Serie = this.calMeterValueByColumn(data, sensor2Id);
      if (!this.isDuoMeter) {
        var sensor3Id = this.deviceId + this.sensorType3BoxCard;
        this.sensor3Serie = this.calMeterValueByColumn(data, sensor3Id);
      }
    },
    calMeterValueByColumn(data, colName) {
      let dataSeries = [];
      for (let index = data.length-1; index >= 0; index--) {
        let colData = {
          y: data[index][colName] ? data[index][colName].toFixed(2) : 0,
          x: data[index]['time'] ? data[index]['time'] : data[index]['date']
        };
        dataSeries.push(colData);
      }
      return dataSeries;
    },
    mountQuery() {
      this.polling = setInterval(() => {
        this.queryDataByPeriod();
      }, 10 * 1000);
    }
  },

  created() {
    moment.locale("th");
  },

  mounted() {
    this.queryDataByPeriod();
    this.mountQuery();
    // console.log(this.$props);
  },

  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style>
.button-datetime-filter {
  width: 84px;
}
</style>